import { ReadonlyRecord } from '@bimser/core';
import { Record } from 'immutable';

interface IBaseUserPermissionsState {
	canTranslate?: boolean;
	canListDelegations?: boolean;
	canManageDelegations?: boolean;
	canLoginAs?: boolean;
	canCreateAnnouncement?: boolean;
	canDeleteAnnouncement?: boolean;
	canUpdateAnnouncement?: boolean;
	canAccessActivities: boolean;
	canRecycleBin: boolean;
	canCodeRefactor: boolean;
	canManageAccessTokens?: boolean;
	canListAccessTokens?: boolean;
	canCaptureActive: boolean;
	canCaptureAbbyyUsed: boolean;
	canViewAI: boolean;
}

export interface IUserPermissionsState extends IBaseUserPermissionsState {}

export interface IReadonlyUserPermissionsState extends IBaseUserPermissionsState {}

export type UserPermissionsState = ReadonlyRecord<IReadonlyUserPermissionsState>;

export const UserPermissionsStateFactory = Record<IReadonlyUserPermissionsState>({
	//canChangeLanguage: false,
	canTranslate: false,
	canListDelegations: false,
	canManageDelegations: false,
	canLoginAs: false,
	canCreateAnnouncement: false,
	canDeleteAnnouncement: false,
	canUpdateAnnouncement: false,
	canAccessActivities: false,
	canRecycleBin: false,
	canCodeRefactor: false,
	canManageAccessTokens: false,
	canListAccessTokens: false,
	canCaptureActive: false,
	canCaptureAbbyyUsed: false,
	canViewAI: false
});

export const UserPermissionsStateFactoryFromJS = function (data: IUserPermissionsState) {
	return UserPermissionsStateFactory({
		...data
	});
};
